import React from "react";
import styled from "styled-components";

const NotificationHome = ({ texts }) => {
  return (
    <Wrapper>
      <div className="notification">
        <div className="content">
          <div className="identifier"></div>
          <div className="text">
            {texts.map((text, index) => (
              <div key={`notification-${index}`}>
                {text}
                <hr />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="number">
        <p></p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .notification {
    height: 8%;
    width: 20%;
    margin-top: 15%;
    position: absolute;
    right: 2rem;
    transform-origin: right;
    -webkit-animation: notify 3s ease-in-out;
    animation: notify 3s ease-in-out;
  }

  .content {
    display: flex;
    align-items: center;
  }

  @-webkit-keyframes notify {
    0% {
      transform: scaleX(0);
    }
    10% {
      transform: scaleX(1);
    }
    13% {
      transform: scale(1.1);
    }
    16% {
      transform: scale(1);
    }
    55% {
      transform: scaleX(1);
      border-radius: 0%;
    }
    65% {
      transform: scaleX(0.25);
      border-radius: 50%;
    }
    95% {
      transform: scaleX(0.25);
      border-radius: 50%;
    }
    100% {
      transform: scaleX(0);
    }
  }

  @keyframes notify {
    0% {
      transform: scaleX(0);
    }
    10% {
      transform: scaleX(1);
    }
    13% {
      transform: scale(1.1);
    }
    16% {
      transform: scale(1);
    }
    55% {
      transform: scaleX(1);
      border-radius: 0%;
    }
    65% {
      transform: scaleX(0.25);
      border-radius: 50%;
    }
    95% {
      transform: scaleX(0.25);
      border-radius: 50%;
    }
    100% {
      transform: scaleX(0);
    }
  }

  .identifier {
    position: absolute;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: var(--clr-primary);
    margin-left: 7.5px;
    -webkit-animation: exit 3s ease-in-out;
    animation: exit 3s ease-in-out;
  }

  .text {
    position: absolute;
    padding: 1rem;
    background-color: var(--clr-primary);
    margin-left: 40px;
    -webkit-animation: exit 3s ease-in-out;
    animation: exit 3s ease-in-out;

    hr {
      border-top: var(--clr-grey-1) 0.01px solid;
      margin-top: 4px;
    }
  }

  @-webkit-keyframes exit {
    0% {
      opacity: 1;
    }
    55% {
      opacity: 1;
    }
    65% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes exit {
    0% {
      opacity: 1;
    }
    55% {
      opacity: 1;
    }
    65% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  .number {
    position: absolute;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    color: #94dacd;
    margin-top: -40px;
    margin-left: 557px;
    -webkit-animation: enter 3s ease-in-out;
    animation: enter 3s ease-in-out;
  }

  @-webkit-keyframes enter {
    0% {
      opacity: 0;
    }
    55% {
      opacity: 0;
    }
    65% {
      opacity: 1;
      transform: scaleX(1);
    }
    95% {
      opacity: 1;
      transform: scaleX(1);
    }
    100% {
      opacity: 0;
      transform: scaleX(1);
    }
  }

  @keyframes enter {
    0% {
      opacity: 0;
    }
    55% {
      opacity: 0;
    }
    65% {
      opacity: 1;
      transform: scaleX(1);
    }
    95% {
      opacity: 1;
      transform: scaleX(1);
    }
    100% {
      opacity: 0;
      transform: scaleX(1);
    }
  }

  @media (max-width: 992px) {
    .identifier {
      display: none;
    }

    .notification {
      right: auto;
      height: auto;
      width: auto;
      position: relative;
    }
    .text {
      position: relative;
      padding: 1rem;
      margin-left: auto;
    }
  }
`;

export default NotificationHome;
